import i18n from "./config";

export const myT = (key: string, ns: string, interpolation?: Record<string, any>) => {
  return i18n.t(key, { ns, ...interpolation });
};

export const myChangeLanguage = (lng: string) => i18n.changeLanguage(lng);
